package com.ijoin.ui.components

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.ConfirmationNumber
import androidx.compose.material.icons.filled.Home
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.outlined.Add
import androidx.compose.material.icons.outlined.ConfirmationNumber
import androidx.compose.material.icons.outlined.Home
import androidx.compose.material.icons.outlined.Person
import androidx.compose.material3.Icon
import androidx.compose.material3.NavigationBar
import androidx.compose.material3.NavigationBarItem
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.NavigationBarItemDefaults
import androidx.compose.material3.Text
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.ijoin.i18n.strings
import com.ijoin.platform.isWebMobile
import com.ijoin.ui.design.EventCardAccent
import com.ijoin.ui.design.EventCardAccentSoft
import com.ijoin.ui.design.EventCardRailContent
import com.ijoin.ui.design.EventCardSurface
import com.ijoin.ui.test.TestTags

@Composable
fun MainBottomNavigationBar(
    selectedTab: String,
    onTabSelected: (String) -> Unit,
    modifier: Modifier = Modifier
) {
    val strings = strings()
    val navHeight = if (isWebMobile()) 70.dp else 110.dp
    val itemColors = NavigationBarItemDefaults.colors(
        selectedIconColor = EventCardAccent,
        selectedTextColor = EventCardAccent,
        indicatorColor = EventCardAccentSoft,
        unselectedIconColor = EventCardRailContent,
        unselectedTextColor = EventCardRailContent
    )

    NavigationBar(
        modifier = modifier.height(navHeight), // slimmer on mobile web
        containerColor = EventCardSurface,
        tonalElevation = 6.dp
    ) {
        NavigationBarItem(
            selected = selectedTab == "home",
            onClick = { onTabSelected("home") },
            modifier = Modifier.weight(0.8f).testTag(TestTags.HomeScreen.HOME_TAB),
            icon = {
                Icon(
                    imageVector = if (selectedTab == "home") Icons.Filled.Home else Icons.Outlined.Home,
                    contentDescription = strings.home
                )
            },
            label = {
                Text(
                    text = strings.home,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                    textAlign = TextAlign.Center
                )
            },
            colors = itemColors
        )

        NavigationBarItem(
            selected = selectedTab == "create",
            onClick = { onTabSelected("create") },
            modifier = Modifier.weight(1.4f).testTag(TestTags.HomeScreen.CREATE_BUTTON),
            icon = {
                Icon(
                    imageVector = if (selectedTab == "create") Icons.Filled.Add else Icons.Outlined.Add,
                    contentDescription = strings.createEvent
                )
            },
            label = {
                Text(
                    text = strings.createEvent,
                    modifier = Modifier.fillMaxWidth(),
                    maxLines = 1,
                    softWrap = false,
                    overflow = TextOverflow.Ellipsis,
                    textAlign = TextAlign.Center,
                    style = MaterialTheme.typography.labelSmall,
                    lineHeight = 12.sp
                )
            },
            colors = itemColors
        )

        NavigationBarItem(
            selected = selectedTab == "tickets",
            onClick = { onTabSelected("tickets") },
            modifier = Modifier.weight(0.8f).testTag(TestTags.HomeScreen.TICKETS_TAB),
            icon = {
                Icon(
                    imageVector = if (selectedTab == "tickets") Icons.Filled.ConfirmationNumber else Icons.Outlined.ConfirmationNumber,
                    contentDescription = strings.tickets
                )
            },
            label = {
                Text(
                    text = strings.tickets,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                    textAlign = TextAlign.Center
                )
            },
            colors = itemColors
        )

        NavigationBarItem(
            selected = selectedTab == "profile",
            onClick = { onTabSelected("profile") },
            modifier = Modifier.weight(0.8f),
            icon = {
                Icon(
                    imageVector = if (selectedTab == "profile") Icons.Filled.Person else Icons.Outlined.Person,
                    contentDescription = strings.profile
                )
            },
            label = {
                Text(
                    text = strings.profile,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                    textAlign = TextAlign.Center
                )
            },
            colors = itemColors
        )
    }
}
